import styled from "styled-components";

export const VideoLive = styled.video`
  width: 100%;
  max-height: 80vh;
  aspect-ratio: 16 / 9;
`;

export const Container = styled.div.attrs({})`
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 24px 56px ${p => p.theme.palette.colors.shadowStrong};
    @media (max-width: 550px) {
    padding: 18px;
  }
`;

export const TherapistsContainer = styled.div.attrs({})`
  background-color: ${p => p.theme.palette.colors.white};
  display: flex;
  border-top: 1px solid ${p => p.theme.palette.colors.lightshadow};
  flex-direction: column;
  gap: 24px;
  padding-top: 16px;
`;

export const Content = styled.div.attrs({})`
  padding: 40px clamp(18px, 3vw, 40px);
  display: flex;
  flex-direction: column;
  gap: 24px;

`;

export const TherapistsTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: clamp(30px, 4vw, 40px);
  font-weight: 700;
  line-height: 1.04;
  letter-spacing: -0.04em;
  color: ${p => p.theme.palette.colors.text};
`;
export const FaqTitle = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${p => p.theme.palette.colors.subdued};
`;
export const InputSearchContainer = styled.div.attrs({
})`
    width: 328px;
    @media(max-width: 450px) {
      width: 100%;
    };
`;
